import {useSetAtom} from "jotai/index";
import {DialAtom} from "../../atoms";
import React, {useContext, useMemo} from "react";
import {SignInContext} from "../../../../context/SignInContext";
import {grey} from "@mui/material/colors";
import {IconDialpad} from "@tabler/icons-react";
import {Button} from "@mui/material";
import {DialModal} from "./dial-modal";

export const DialButton = ({project}) => {
  const {currentUser} = useContext(SignInContext);
  const setOpenDial = useSetAtom(DialAtom);

  const hasVdn = useMemo(() => {
    const vdnManager = project?.vdnManager || {};
    return !!vdnManager[currentUser?.username];

  }, [currentUser, project?.vdnManager])

  return (
    <>
      <DialModal project={project} />
      <Button
        // disabled={!hasVdn}
        onClick={() => setOpenDial(true)}
        sx={{
          borderRadius: 1,
          textTransform: "capitalize",
          color: "dark.main",
          "&.active": {
            bgcolor: grey[200],
            borderRadius: 1,
            // fontWeight: 500
          }
        }}
        startIcon={<IconDialpad size={18} />}
      >
        Dial
      </Button>
    </>
  )
}